import React from 'react'
import {useEnumTranslations} from '@common/utils/translations'
import {EnumType} from '@common/utils/types'
import type {PatientAppointmentItem, SlotStatusType} from '@common/models'

import {
  ListCard,
  Row,
  RowLeft,
  ActionsContainer,
  HistoryButton,
  ActionButton,
  EmptyState,
} from './AppointmentManagementPage.styled'

import {Typography} from '~/components/general/typography/Typography'
import {Container} from '~/components/general/container/Container'
import {Icon} from '~/components/general/icon/Icon'

type AppointmentsListProps = {
  title: string
  items: PatientAppointmentItem[]
  onClickHistory: (slotId: string) => void
  onClickReschedule?: (slotId: string) => void
  onClickCancel?: (slotId: string) => void
}

export const AppointmentsList: React.FC<AppointmentsListProps> = ({
  title,
  items,
  onClickHistory,
  onClickReschedule,
  onClickCancel,
}) => {
  const {translateEnumValue} = useEnumTranslations()

  return (
    <ListCard>
      <Typography weight="bold" size="lg">
        {title}
      </Typography>
      <Container direction="column" spacing={0}>
        {items.map((item) => (
          <Row key={item.slotId}>
            <RowLeft $cancelled={item.status === 'CANCELLED'}>
              <Typography weight="bold">{`${item.date} ${item.time}`}</Typography>
              <Typography>{item.serviceName || '-'}</Typography>
              <Typography>
                {translateEnumValue(
                  EnumType.SlotStatusType,
                  item.status as SlotStatusType,
                  '-',
                )}
              </Typography>
            </RowLeft>
            <ActionsContainer>
              {onClickReschedule && item.status === 'SCHEDULED' && (
                <ActionButton
                  color="secondary"
                  size="sm"
                  onClick={() => onClickReschedule(item.slotId)}
                  startIcon={<Icon name="Edit" size="sm" />}>
                  Reschedule
                </ActionButton>
              )}
              {onClickCancel && item.status === 'SCHEDULED' && (
                <ActionButton
                  color="secondary"
                  size="sm"
                  onClick={() => onClickCancel(item.slotId)}
                  startIcon={<Icon name="Close" size="sm" />}>
                  Cancel
                </ActionButton>
              )}
              <HistoryButton
                color="primary"
                size="sm"
                onClick={() => onClickHistory(item.slotId)}
                startIcon={<Icon name="DocumentList" size="sm" />}>
                History
              </HistoryButton>
            </ActionsContainer>
          </Row>
        ))}
        {items.length === 0 && (
          <EmptyState>
            <Typography color="muted">—</Typography>
          </EmptyState>
        )}
      </Container>
    </ListCard>
  )
}
